import f from '../__mocks__/datas/features.json';
import r from '../__mocks__/datas/roles.json';

const features = f as IFeature[];
const roles = r as IAdvancedRole[];

import { IAdvancedRole, TAdvancedRoleSlug } from '@/features/roles/store/models/advancedRole.model';
import { IFeature } from '@/features/roles/store/models/features.model';

export class RoleServices {
  static queryKey = 'Roles';
  static GetRole = async (roleSlug: TAdvancedRoleSlug): Promise<IAdvancedRole> => {
    const role = roles.find((role) => role.slug === roleSlug) as IAdvancedRole;
    return role;
  };
  static async GetAllRoles(mapFeatures: true): Promise<IAdvancedRole<IFeature>[]>;
  static async GetAllRoles(mapFeatures: false): Promise<IAdvancedRole[]>;
  static async GetAllRoles(mapFeatures?: undefined): Promise<IAdvancedRole[]>;
  static async GetAllRoles(mapFeatures?: boolean): Promise<IAdvancedRole<IFeature>[] | IAdvancedRole[]> {
    if (mapFeatures) {
      return roles.map((role) => ({
        ...role,
        features: role.features.map((featureSlug) =>
          features.find((configFeature) => configFeature.slug === featureSlug),
        ),
      }));
    } else {
      return roles;
    }
  }
  static async GetAllFeatures(): Promise<IFeature[]> {
    return features;
  }
}
